// Stock photos mapped to article slugs
export const ARTICLE_IMAGES = {
    'why-stress-makes-it-harder-to-fall-asleep':
        'https://images.unsplash.com/photo-1721990469247-c9cbad91e8ef?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'the-science-of-nighttime-overthinking':
        'https://images.unsplash.com/photo-1578571020914-1115acfd826e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'why-your-brain-needs-deep-sleep-for-stress-recovery':
        'https://images.unsplash.com/photo-1615890265358-7a4c4df30036?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'how-modern-work-schedules-disrupt-your-circadian-rhythm':
        'https://images.unsplash.com/photo-1758876204245-ee540a3af69f?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'the-link-between-burnout-and-poor-sleep':
        'https://images.unsplash.com/photo-1758874573615-a4fa078b1980?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'the-neuroscience-of-falling-asleep-faster':
        'https://images.unsplash.com/photo-1728675437273-d83d4cfaf938?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'why-sleep-quality-matters-more-than-sleep-duration':
        'https://images.unsplash.com/photo-1706894854720-f5b6338443f8?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'how-stress-changes-your-brain-at-night':
        'https://images.unsplash.com/photo-1758687127236-0da5ff52f4bc?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'the-45-minute-wind-down-routine-backed-by-sleep-science':
        'https://images.unsplash.com/photo-1698953186103-d0e9f99abc4b?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'the-cortisol-awakening-response-explained':
        'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'magnesium-for-sleep-glycinate-citrate-oxide-explained':
        'https://images.unsplash.com/photo-1607874963930-2edecc67a25a?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'why-you-wake-up-at-3am-and-how-to-stay-asleep':
        'https://images.unsplash.com/photo-1549675584-c22bde15df72?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'l-theanine-calm-focus-without-drowsiness':
        'https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'how-caffeine-really-affects-your-sleep':
        'https://images.unsplash.com/photo-1509042239860-f550ce710b93?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
    'evening-screens-and-sleep-what-blue-light-does':
        'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
};
